export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";
export const SET_NOTIFICATION = "SET_NOTIFICATION";

export const FETCH_NOTIFICATION_DETAIL = "FETCH_NOTIFICATION_DETAIL";
